import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ControlContainer, NgForm } from '@angular/forms';
import { BackupStationSet } from '../../model/yard-structure.model';

@Component({
    selector: 'app-backup-reference',
    templateUrl: './backup-reference.component.html',
    styleUrls: ['./backup-reference.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})

export class BackupReferenceComponent {

  @Input() reference: BackupStationSet;

  @Output() onDelete = new EventEmitter<BackupStationSet>();

  remove() {
    this.onDelete.next(this.reference);
  }

}
